import { AuthenticatedTemplate } from "@azure/msal-react";
import { ReactElement, useContext, useEffect } from "react";
import "./HelpContainer.css";
import { pageNames } from "../../authConfig";
import { PageContainer } from "./PageContainer";
import HelpContainer from "./HelpContainer";
import { ApplicationLocationContext } from "../../utils/ApplicationState";

function HelpView(): ReactElement {
  const { setState } = useContext(ApplicationLocationContext);

  useEffect(() => {
    setState({
      path: [pageNames.helpPage],
    });
  }, [setState]);

  return (
    <AuthenticatedTemplate>
      <PageContainer>{<HelpContainer></HelpContainer>}</PageContainer>
    </AuthenticatedTemplate>
  );
}

export default HelpView;
